import { render, staticRenderFns } from "./archived_users.vue?vue&type=template&id=3053c9cf&"
import script from "./archived_users.vue?vue&type=script&lang=js&"
export * from "./archived_users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports